export const REDACTED_PARAM = "REDACTED";

/** Redacts search params from a URL
 * A query string is a place we can leak sensitive info. Some examples are:
 * One time use tokens (password reset, 2FA setup links, etc)
 * Filter/search parameters (email activity advanced search)
 * Returns an empty string if the URL cannot be parsed.
 */
export const redactSearchParams = (url: string) => {
  try {
    const outputUrl = new URL(url);
    outputUrl.searchParams.forEach((_, key) => {
      outputUrl.searchParams.set(key, REDACTED_PARAM);
    });
    return outputUrl.toString();
  } catch {
    return "";
  }
};
